import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupChannelsLayout } from "@/features/study-group-channels/components/StudyGroupChannelsLayout";

const ProtoForUserRoute = () => (
  <StudyGroupChannelsLayout isUserMode studyGroupId={1} />
);

export const Route = createFileRoute("/proto-for-user")({
  component: ProtoForUserRoute,
});
